import { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

function Header({ user, onLogout })
{
   const [menuOpen, setMenuOpen] = useState(false);
   const isAdmin = user?.username === 'admin';

   return (
      <header className="app-header">
         <div className="header-content">
            <Link to="/" className="header-title">Ma galerie BD</Link>

            <div className="header-right">
               <span className="user-name">👤 { user?.username }</span>

               { isAdmin && (
                  <div className="burger-menu">
                     <button
                        className="burger-button"
                        onClick={ () => setMenuOpen(!menuOpen) }
                     >
                        ☰
                     </button>

                     { menuOpen && (
                        <div className="dropdown-menu">
                           <Link to="/admin/settings" onClick={ () => setMenuOpen(false) }>
                              Admin
                           </Link>
                           <Link to="/admin/albums" onClick={ () => setMenuOpen(false) }>
                              Manage Albums
                           </Link>
                        </div>
                     ) }
                  </div>
               ) }

               <button onClick={ onLogout } className="logout-button">
                  Logout
               </button>
            </div>
         </div>
      </header>
   );
}

export default Header;